import { formatMoney } from '@aeris/money';
import { footerBlocks, headerBlocks, } from "./receipt-template.js";
const two = (value) => String(value).padStart(2, '0');
/** `13/09/2026`, no relógio de quem imprime — o mesmo da tela. */
export const printedDay = (at) => `${two(at.getDate())}/${two(at.getMonth() + 1)}/${String(at.getFullYear())}`;
const plain = (amount) => formatMoney(amount, { symbol: false });
export const statementFor = (input) => {
    const blocks = headerBlocks({
        company: input.company,
        template: input.template,
    });
    blocks.push({ kind: 'rule' }, { kind: 'text', text: 'EXTRATO DO CLIENTE', align: 'center', bold: true }, { kind: 'rule' }, { kind: 'pair', label: 'Cliente', value: input.customer.name });
    if (input.customer.document !== null) {
        blocks.push({
            kind: 'pair',
            label: 'CPF/CNPJ',
            value: input.customer.document,
        });
    }
    blocks.push({ kind: 'pair', label: 'Posição em', value: printedDay(input.asOf) }, { kind: 'rule' });
    if (input.entries.length === 0) {
        blocks.push({
            kind: 'text',
            text: 'Nada em aberto.',
            align: 'center',
        });
    }
    // Duas linhas por título, como o recibo: a descrição é mais larga que
    // qualquer bobina, e o vencimento com o valor ficam juntos embaixo dela.
    for (const entry of input.entries) {
        blocks.push({ kind: 'text', text: entry.description });
        for (const item of entry.items ?? []) {
            blocks.push({
                kind: 'pair',
                label: `  ${item.quantity} × ${item.description}`,
                value: plain(item.total),
            });
        }
        blocks.push({
            kind: 'pair',
            label: entry.daysOverdue > 0
                ? `  venceu ${printedDay(entry.dueAt)} (${String(entry.daysOverdue)} ${entry.daysOverdue === 1 ? 'dia' : 'dias'})`
                : `  vence ${printedDay(entry.dueAt)}`,
            value: plain(entry.outstanding),
        });
    }
    blocks.push({ kind: 'rule' }, { kind: 'pair', label: 'Vencido', value: plain(input.overdueTotal) }, { kind: 'pair', label: 'A vencer', value: plain(input.upcomingTotal) }, { kind: 'text', text: 'TOTAL EM ABERTO', big: true, bold: true }, {
        kind: 'text',
        text: formatMoney(input.total),
        align: 'right',
        big: true,
        bold: true,
    });
    if (input.payments.length > 0) {
        blocks.push({ kind: 'rule' }, { kind: 'text', text: 'Últimos pagamentos', bold: true });
        for (const payment of input.payments) {
            blocks.push({
                kind: 'pair',
                label: `${printedDay(payment.settledOn)} ${payment.method ?? ''}`.trim(),
                value: plain(payment.paid),
            });
        }
    }
    blocks.push({ kind: 'rule' }, ...footerBlocks(input.template, 'statement'), { kind: 'feed', lines: 2 }, { kind: 'cut' });
    return { kind: 'report', title: 'Extrato do cliente', blocks };
};
//# sourceMappingURL=statement.js.map